// src/v-permission.js
function normalizeRoles(val) {
  if (!val) return []
  if (Array.isArray(val)) return val
  if (typeof val === 'string') return [val]
  return []
}

export default {
  mounted(el, binding) {
    const expectedRoles = normalizeRoles(binding.value)
    const instance = binding.instance
    const store = instance?.$store

    const apply = () => {
      const ok = typeof instance?.$canView === 'function'
        ? instance.$canView(...expectedRoles)
        : expectedRoles.includes(store?.state?.role)

      el.style.display = ok ? '' : 'none'
    }

    apply()

    el.__perm_unsub = store?.subscribe((mutation) => {
      if (
        mutation.type === 'setRole' ||
        mutation.type === 'clearRole' ||
        mutation.type === 'setUser' ||
        mutation.type === 'clearUser'
      ) {
        apply()
      }
    })
  },
  beforeUnmount(el) {
    if (typeof el.__perm_unsub === 'function') el.__perm_unsub()
    delete el.__perm_unsub
  }
}
